import React, { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import BottomNav from '../components/BottomNav';
import { Calculator, Search, Wand2, GitBranch } from 'lucide-react';
import TimelineCalculatorTab from '../components/ZapTools/TimelineCalculatorTab';
import SectionEquivalenciesTab from '../components/ZapTools/SectionEquivalenciesTab';
import ModeSelectionWizardTab from '../components/ZapTools/ModeSelectionWizardTab';
import ModeActivitiesTab from '../components/ZapTools/ModeActivitiesTab';
import { trackActivity } from '../utils/trackActivity';

export default function ZapToolsPage() {
  const [activeTab, setActiveTab] = useState('timeline');

  useEffect(() => {
    // Track page view on mount
    trackActivity('zap_tool', 'Zap Tools page opened', 'Zap Tools');
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const tabNames = {
      'timeline': 'Timeline Calculator',
      'equivalencies': 'Section Equivalencies',
      'wizard': 'Mode Selection Wizard',
      'activities': 'Process Flow'
    };
    trackActivity('zap_tool', `Used ${tabNames[tab]}`, tabNames[tab]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-slate-100 to-emerald-50 dark:from-slate-900 dark:via-slate-800 dark:to-emerald-900 pb-24">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl lg:text-5xl font-bold text-slate-800 dark:text-slate-100 mb-2" style={{ fontFamily: 'IBM Plex Sans' }}>
            Zap Tools
          </h1>
          <p className="text-slate-600 dark:text-slate-400">Powerful utilities for Philippine procurement</p>
        </div>

        {/* Tools Tabs */}
        <Tabs value={activeTab} onValueChange={handleTabChange} className="w-full">
          <TabsList className="grid w-full grid-cols-4 mb-8">
            <TabsTrigger value="timeline" className="flex items-center gap-2">
              <Calculator className="w-4 h-4" />
              <span className="hidden sm:inline">Timeline</span>
            </TabsTrigger>
            <TabsTrigger value="equivalencies" className="flex items-center gap-2">
              <Search className="w-4 h-4" />
              <span className="hidden sm:inline">Sections</span>
            </TabsTrigger>
            <TabsTrigger value="wizard" className="flex items-center gap-2">
              <Wand2 className="w-4 h-4" />
              <span className="hidden sm:inline">Mode Wizard</span>
            </TabsTrigger>
            <TabsTrigger value="activities" className="flex items-center gap-2">
              <GitBranch className="w-4 h-4" />
              <span className="hidden sm:inline">Process Flow</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="timeline">
            <TimelineCalculatorTab />
          </TabsContent>

          <TabsContent value="equivalencies">
            <SectionEquivalenciesTab />
          </TabsContent>

          <TabsContent value="wizard">
            <ModeSelectionWizardTab />
          </TabsContent>

          <TabsContent value="activities">
            <ModeActivitiesTab />
          </TabsContent>
        </Tabs>
      </div>

      <BottomNav />
    </div>
  );
}
